import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { DomainService } from 'app/core/services/domain.service';
import { RedirectService } from '../services/redirect.service';

@Injectable()
export class SelfRegisterGuard implements CanActivate {
  constructor(
    private service: DomainService,
    private redirectService: RedirectService
  ) {
  }
  canActivate(): boolean {
    if (this.service.allowSelfRegister()) {
      return true;
    }
    this.redirectService.redirectToPublic();
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/guards/self-register.guard.ts